import { AnimationConfig } from "@dineout-payment-success-ui/helpers/index";

export const CALLOUTS_BANNER_LOTTIE_PROPS = {
    ...AnimationConfig(true),
    loop: true,
    playIfVisible: false,
};

export const CALLOUTS_BANNER_DIMENSIONS = {
    titleLottieHeight: "28px",
    bannerMinHeight: "90px",
    bannerBorderRadius: "16px",
    calloutImageWidthSize: "111px",
    calloutImageHeightSize: "83px",
    calloutImageRightOffset: "-15px",
    calloutImageTopOffset: "-5px",
    calloutTitleWidth: "232px",
    calloutDescriptionWidth: "266px",
};
